/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('product-information')) {
  customElements.define('product-information', class ProductInformation extends HTMLElement {
    constructor() {
      super();
      this.variantRevision = 0;
      this.dataCache = new Map(); // Cache for pre-fetched data
      this.init();
    }

    init() {
      this.cacheDOMElements();
      this.bindEventHandlers();
    }

    cacheDOMElements() {
      /* ===== Cache any information that we'll need later ===== */
      this.sectionId = this.getAttribute('data-section-id');
      this.originalSectionId = this.getAttribute('data-original-section-id');
      this.isQuickView = this.dataset.quickView === 'true';
      this.productForm = this.querySelector('product-form');
      this.stickyAddToCart = this.querySelector('sticky-add-to-cart');
      this.stickyContainer = this.classList.contains('product-sticky') ? this : null;
      this.stickyHeader = document.querySelector('.header-section:has(.header-is-sticky)');
      this.enableURLUpdate = this.dataset.enableUrlUpdate === 'true';
      this.mainProductURL = this.dataset.url;
      this.showOnlyVariantMedia = this.dataset.showOnlyVariantMedia === 'true';
    }

    connectedCallback() {
      /* ===== Gather options for the current variant, handle sticky form offset, attach event listeners ===== */
      this.setStickyOffset();
      this.attachEventListeners();
      this.prefetchVariantData();
      this.setupVariantSafety();
      this.isCombinedListing = this.dataset.isCombinedListing === 'true';
    }

    setupVariantSafety() {
      if (this.dataset.isCombinedListing === 'true') return;
      const source = this.querySelector('[data-variant-safety-data]');
      let safetyData;
      try { safetyData = JSON.parse(source?.textContent || ''); }
      catch {
        if (!this.variantSafetyObserver) {
          this.variantSafetyObserver = new MutationObserver(() => this.setupVariantSafety());
          this.variantSafetyObserver.observe(this, {childList: true, subtree: true, characterData: true});
        }
        return;
      }
      this.variantSafetyObserver?.disconnect();
      this.variantSafetyObserver = null;
      this.removeVariantSafety?.();
      this.setAttribute('data-variant-safety-ready', 'true');
      this.variantSafetyData = safetyData;
      this.requestedOptions = this.variantSafetyData.selected?.options?.slice();
      this.variantSafetyActive = false;
      this.variantReady = true;
      this.variantRevision = 0;
      this.syncOpeningAppMedia();
      const onChoice = event => {
        const button = event.target.closest('[data-option-value]');
        const group = button?.closest('[data-option][data-option-type]');
        if (!group || !this.contains(group)) return;
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        const position = this.variantSafetyData.options.indexOf(group.dataset.option);
        if (position < 0 || !this.requestedOptions) return;
        const options = this.requestedOptions.slice();
        options[position] = button.dataset.optionValue;
        const variant = this.resolveSafetyVariant(options);
        if (!variant) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showVariantSafetyMessage(this.variantSafetyData.messages.notOffered);
          return;
        }
        if (event.isTrusted && this.closest?.('[data-product-content-wrapper]')?.querySelector('product-media[data-opening-product-media-id]') &&
            options.some((value, index) => value !== this.requestedOptions[index])) {
          this.openingProductChoiceId = variant.id;
        }
        if (event.type === 'keydown') {
          event.preventDefault();
          event.stopImmediatePropagation();
          button.click();
          return;
        }
        this.variantSafetyActive = true;
        this.requestedOptions = options;
        this.showVariantSafetyMessage('');
        this.lockVariantPurchase();
        queueMicrotask(() => this.handleVariantChange({sectionId: this.sectionId, variant,
          productURL: this.mainProductURL, fetchURL: `${this.mainProductURL}?variant=${variant.id}`}));
      };
      const onSubmit = event => {
        if (this.safetyProductForms().includes(event.target) && !this.isVariantPurchaseSafe(event.target)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.addEventListener('click', onChoice, true);
      this.addEventListener('keydown', onChoice, true);
      this.addEventListener('submit', onSubmit, true);
      this.removeVariantSafety = () => {
        this.removeEventListener('click', onChoice, true);
        this.removeEventListener('keydown', onChoice, true);
        this.removeEventListener('submit', onSubmit, true);
      };
    }

    syncOpeningAppMedia(variant) {
      const wrapper = this.closest?.('[data-product-content-wrapper]');
      const media = wrapper?.querySelector('product-media[data-opening-product-media-id]');
      if (!media) return;
      this.cancelOpeningAppSync?.();
      const opening = !variant && !new URLSearchParams(window.location.search).has('variant');
      const mediaId = opening ? media.dataset.openingProductMediaId : (variant || this.variantSafetyData.selected)?.featured_media?.id;
      const image = media.querySelector(`[data-slider-main] [data-media-id="${mediaId}"] img`);
      if (!image) return;
      const filename = source => {
        try { return new URL(source, window.location.href).pathname.split('/').pop(); }
        catch { return ''; }
      };
      const target = filename(image.currentSrc || image.src);
      if (!target) return;
      const caption = wrapper.querySelector('[data-opening-product-caption]');
      if (caption) caption.hidden = !opening;
      let stopped = false;
      let frame = null;
      let observer;
      let timer;
      let retryTimer;
      const stop = () => {
        stopped = true;
        observer?.disconnect();
        if (frame !== null) cancelAnimationFrame(frame);
        clearTimeout(timer);
        clearTimeout(retryTimer);
        wrapper.removeEventListener('pointerdown', manual, true);
        wrapper.removeEventListener('keydown', manual, true);
      };
      const manual = event => { if (event.isTrusted && event.target.closest('[data-product-media-wrapper]')) stop(); };
      const sync = () => {
        frame = null;
        clearTimeout(retryTimer);
        if (stopped) return;
        const galleries = Array.from(wrapper.querySelectorAll('.pwzrswiper-container')).filter(element => element.getClientRects().length);
        let synced = false;
        for (const gallery of galleries) {
          const host = gallery.closest('.rio-media-gallery');
          if (host && caption) {
            let appCaption = host.querySelector(':scope > [data-opening-app-caption]');
            if (!appCaption) {
              appCaption = caption.cloneNode(true);
              appCaption.removeAttribute('data-opening-product-caption');
              appCaption.setAttribute('data-opening-app-caption', '');
              host.appendChild(appCaption);
            }
            appCaption.hidden = !opening;
          }
          const swiper = gallery.swiper;
          if (!swiper?.initialized || swiper.destroyed) continue;
          const slides = Array.from(gallery.querySelectorAll('.pwzrswiper-slide'));
          const index = slides.findIndex(slide => filename(slide.querySelector('img')?.getAttribute('src')) === target);
          if (index < 0) continue;
          const logicalIndex = Number(slides[index].getAttribute('data-swiper-slide-index') ?? index);
          if (swiper.params.loop && swiper.slideToLoop) swiper.slideToLoop(logicalIndex, 0, false);
          else swiper.slideTo(index, 0, false);
          synced = true;
        }
        if (synced) stop();
        else retryTimer = setTimeout(schedule, 100);
      };
      const schedule = () => { if (!stopped && frame === null) frame = requestAnimationFrame(sync); };
      observer = new MutationObserver(schedule);
      observer.observe(wrapper, {childList: true, subtree: true});
      wrapper.addEventListener('pointerdown', manual, true);
      wrapper.addEventListener('keydown', manual, true);
      timer = setTimeout(stop, 10000);
      this.cancelOpeningAppSync = stop;
      schedule();
    }

    resolveSafetyVariant(options = this.requestedOptions) {
      return this.variantSafetyData?.variants.find(variant =>
        variant.options.length === options?.length && variant.options.every((value, index) => value === options[index]));
    }

    showVariantSafetyMessage(message) {
      let element = this.querySelector(':scope > [data-variant-safety-message]');
      if (!element) {
        element = document.createElement('p');
        element.setAttribute('data-variant-safety-message', '');
        element.setAttribute('role', 'status');
        element.setAttribute('aria-live', 'polite');
        this.prepend(element);
      }
      if (element) {
        element.textContent = message;
        element.hidden = !message;
      }
    }

    lockVariantPurchase() {
      this.variantReady = false;
      this.safetyProductForms().forEach(form => form.querySelectorAll('[name="id"]').forEach(input => { input.disabled = true; }));
      this.safetyProductForms().forEach(form => form.querySelectorAll('[name="add"]').forEach(button => { button.disabled = true; }));
      this.safetyProductForms().forEach(form => form.querySelectorAll('.shopify-payment-button').forEach(element => { element.hidden = true; }));
    }

    safetyProductForms() {
      return Array.from(this.querySelectorAll('form[action*="/cart/add"]')).filter(form =>
        form.closest('product-information') === this &&
        form.querySelector('[name="product-id"]')?.value === String(this.variantSafetyData?.productId));
    }

    isVariantPurchaseSafe(form) {
      if (!this.variantSafetyActive) return true;
      const variant = this.resolveSafetyVariant();
      if (form && !this.safetyProductForms().includes(form)) return true;
      const input = (form || this.safetyProductForms()[0])?.querySelector('[name="id"]');
      return Boolean(this.variantReady && variant?.available && input && !input.disabled && String(variant.id) === input.value);
    }

    unlockVariantPurchase() {
      if (!this.variantSafetyActive) return;
      const variant = this.resolveSafetyVariant();
      this.variantReady = Boolean(variant);
      this.safetyProductForms().forEach(form => form.querySelectorAll('[name="id"]').forEach(input => {
        input.value = variant ? String(variant.id) : '';
        input.disabled = !variant?.available;
      }));
      this.safetyProductForms().forEach(form => form.querySelectorAll('[name="add"]').forEach(button => { button.disabled = !variant?.available; }));
      this.safetyProductForms().forEach(form => form.querySelectorAll('.shopify-payment-button').forEach(element => { element.hidden = !variant?.available; }));
    }

    disconnectedCallback() {
      /* ===== Clean up event listeners ===== */
      this.removeEventListeners();
      this.removeVariantSafety?.();
      this.variantSafetyObserver?.disconnect();
      this.variantSafetyObserver = null;
      this.cancelOpeningAppSync?.();
    }

    bindEventHandlers() {
      /* ===== Bind methods to maintain the 'this' context ===== */
      this.resizeHandler = this.handleResize.bind(this);
      this.onQuantityChange = this.handleQuantityChange.bind(this);
      this.onVariantChange = this.handleVariantChange.bind(this);
      this.onCartAdded = this.handleCartAdded.bind(this);
      this.resetQuantityInput = this.resetQuantityInput.bind(this);
      this.prefetchVariantData = this.prefetchVariantData.bind(this);
      this.resetQuantityInput = this.resetQuantityInput.bind(this);
    }

    attachEventListeners() {
      // On resize we need to update the sticky form offset
      window.addEventListener('resize', this.resizeHandler);
      // Listen for quantity changes
      eventBus.on('qty:change', this.onQuantityChange);
      // Listen for variant changes
      eventBus.on('variant:change', this.onVariantChange);
      // Listen for cart added events
      eventBus.on('cart:added', this.onCartAdded);
    }

    removeEventListeners() {
      /* ===== Remove any event listeners we've attached ===== */
      window.removeEventListener('resize', this.resizeHandler);
      eventBus.off('qty:change', this.onQuantityChange);
      eventBus.off('variant:change', this.onVariantChange);
      eventBus.off('cart:added', this.onCartAdded);
    }

    prefetchVariantData() {
      const variants = this.querySelectorAll('[data-product-variant]');
      if (!variants.length) return;

      variants.forEach(variant => {
        const productFetchUrl = variant.getAttribute('data-product-fetch-url');

        if (productFetchUrl && !this.dataCache.has(productFetchUrl)) {
          this.fetchProductData(productFetchUrl).catch(error => {
            console.error(`Failed to fetch data for ${productFetchUrl}:`, error);
          });
        }
      });
    }

    async fetchProductData(productFetchUrl) {
      try {
        const response = await fetch(`${productFetchUrl}&section_id=${this.originalSectionId}`);
        if (!response.ok) {
          throw new Error(`Network response was not ok for ${productFetchUrl}`);
        }
        const data = await response.text();
        const productData = this.extractProductData(data);
        this.dataCache.set(productFetchUrl, productData);
      } catch (error) {
        console.error(`Failed to fetch product data from ${productFetchUrl}:`, error);
      }
    }

    async fetchVariantData(productFetchUrl, context) {
      /* ===== Fetch the product data if it's not already cached ===== */
      if (!this.dataCache.has(productFetchUrl) || window.Shopify.designMode) {
        await this.fetchProductData(productFetchUrl);
      }
      this.updateDOMWithData(context);
    }

    extractProductData(data) {
      /* ===== Parse the fetched data and return the new product data ===== */
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(data, 'text/html');
      const productInformation = htmlDocument.querySelector('product-information');
      const quickViewContent = htmlDocument.querySelector('template[data-quick-view-product]')?.content;

      const quickViewContentInformation = quickViewContent?.querySelector('product-information');
      const productDataElement = this.isQuickView && quickViewContentInformation ? quickViewContentInformation : productInformation;

      const productMedia = htmlDocument.querySelector('[data-product-media-wrapper]');
      const quickViewMedia = quickViewContent?.querySelector('[data-product-media-wrapper]');
      const productBadges = this.isQuickView && quickViewMedia ? quickViewMedia.querySelectorAll('[data-product-badge]') : productMedia?.querySelectorAll('[data-product-badge]');

      if (this.isCombinedListing || productBadges.length) {
        const productMediaElement = this.isQuickView && quickViewMedia ? quickViewMedia : productMedia;
        const productDiv = document.createElement('div');
        productDiv.setAttribute('data-url', productInformation?.getAttribute('data-url'));
        productDiv.appendChild(productMediaElement);
        productDiv.appendChild(productDataElement);

        return productDiv.outerHTML;
      }

      return productDataElement.outerHTML;
    }

    handleResize() {
      /* ===== Handle resizing of the window ===== */
      if (window.Shopify.designMode) {
        // If we're in the theme editor we need to update the sticky form offset
        // We only do this in the editor because it's not necessary in the live site
        // because mobile devices can incorrectly trigger resize events when scrolling
        this.setStickyOffset();
      }
    }

    handleQuantityChange(event) {
      /* ===== Handle changes to the quantity input ===== */

      // Update the quantity input value
      this.productForm = this.querySelector('product-form');
      this.formQuantityInput = this.productForm?.querySelector('[name="quantity"]');

      if (this.formQuantityInput && event.value) {
        if (event.sectionId && event.sectionId !== this.sectionId) return;
        this.formQuantityInput.value = event.value;
      }
    }

    setStickyOffset() {
      if (this.stickyContainer && this.stickyHeader) {
        // Set the top offset of the sticky form to the height of the sticky header
        this.stickyContainer.style.top = `${this.stickyHeader.offsetHeight + 30}px`;
      }
    }

    async handleVariantChange(context) {
      /* ===== Handle changes to the variant ===== */
      if (context.sectionId && context.sectionId !== this.sectionId) return;
      if (context.isCombinedListing) this.variantSafetyActive = false;

      if (this.variantSafetyData && !context.isCombinedListing && this.querySelector('[data-option][data-option-type]')) {
        this.variantSafetyActive = true;
        const resolved = this.resolveSafetyVariant();
        context = {...context, variant: resolved, productURL: this.mainProductURL,
          fetchURL: resolved ? `${this.mainProductURL}?variant=${resolved.id}` : null};
        this.lockVariantPurchase();
      }
      context = {...context, revision: ++this.variantRevision};
      // Update the current variant based on the selected options
      this.currentVariant = context.variant;
      this.productFetchUrl = context.fetchURL;
      this.productUrl = context.productURL;

      // If we don't have a valid variant, handle it and return
      if (!this.currentVariant) {
        this.handleInvalidVariant(context);
        return;
      }

      if (!this.productFetchUrl || !this.productUrl) return;

      // If the variant is available, update the UI
      if (!this.variantSafetyActive) this.toggleAddButton(this.currentVariant.available);
      const isCached = this.dataCache.has(this.productFetchUrl) && !window.Shopify.designMode;

      if (isCached) {
        this.updateDOMWithData(context);
      } else {
        // If the data is not cached, fetch the product data and then update the UI
        await this.fetchVariantData(this.productFetchUrl, context);
      }

      if (context.revision !== this.variantRevision) return;
      // Show the sticky add to cart
      if (this.stickyAddToCart) {
        this.stickyAddToCart.classList.remove('hide');
      }

      // Reset quantity input to 1 on variant change
      this.resetQuantityInput();

      // Refocus on the active radio input
      const activeRadioInput = this.querySelector('input[type="radio"][name^="option-"]:checked');
      if (activeRadioInput && !context.fromSlideChange) {
        activeRadioInput.focus();
      }
    }

    handleInvalidVariant(context = {}) {
      /* ===== Handle an invalid variant ===== */
      if (this.variantSafetyActive) {
        this.lockVariantPurchase();
        this.showVariantSafetyMessage(this.variantSafetyData.messages.invalid);
        return;
      }
      const productUrl = this.productUrl || this.mainProductURL;
      const productFetchUrl = this.buildRequestUrlWithParams(false, productUrl);
      this.fetchNullVariantData(productFetchUrl, context);

      // If the variant is invalid, disable the add to cart button
      this.toggleAddButton(false);
      // If the variant is invalid, set the add to cart button text to "unavailable"
      const addButton = this.productForm?.querySelector('[name="add"]');
      if (!addButton) return;
      const addButtonSpan = addButton.querySelector('[data-add-to-cart-text]');
      if (!addButtonSpan) return;

      addButtonSpan.textContent = addButtonSpan.getAttribute('data-unavailable-text');

      // If the variant is invalid, set the price to "Unavailable"
      const priceElement = this.querySelector('[data-product-price]');
      if (!priceElement) return;
      const priceElementSpan = priceElement.querySelector('span[data-price-text]');
      if (!priceElementSpan) return;

      priceElementSpan.textContent = priceElementSpan.getAttribute('data-unavailable-text');

      // If the variant is invalid, hide the sticky add to cart
      if (this.stickyAddToCart) {
        this.stickyAddToCart.classList.add('hide');
      }
    }

    handleCartAdded(event) {
      /* ===== Handle when a product is added to cart ===== */
      if (event.sectionId && event.sectionId !== this.sectionId) return;
      
      // Reset quantity input to 1 after adding to cart
      this.resetQuantityInput();
    }

    resetQuantityInput() {
      /* ===== Reset the quantity input to 1 when variant changes or after cart addition ===== */
      const quantityInput = this.productForm?.querySelector('[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = '1';
      }
    }

    buildRequestUrlWithParams(shouldFetchFullPage = false, url = null) {
      const params = [];
      const optionValues = this.selectedOptionValues;

      !shouldFetchFullPage && params.push(`section_id=${this.originalSectionId || this.sectionId}`);

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url || this.mainProductURL}?${params.join('&')}`;
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('li[data-product-variant][selected], input[data-product-variant]:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }

    async fetchNullVariantData(productFetchUrl, context = {}) {
      /* ===== Fetch the product data if it's not already cached ===== */
      try {
        const response = await fetch(`${productFetchUrl}`);
        if (!response.ok) {
          throw new Error(`Network response was not ok for ${productFetchUrl}`);
        }
        const data = await response.text();
        const productData = this.extractProductData(data);
        this.dataCache.set(productFetchUrl, productData);
        this.updateNullVariant(productData, context);
      } catch (error) {
        console.error(`Failed to fetch product data from ${productFetchUrl}:`, error);
      }
    }

    updateNullVariant(extractedData, context = {}) {
      if (context.revision !== undefined && context.revision !== this.variantRevision) return;
      const html = this.parseHTML(extractedData);
      const productInformation = html.querySelector('product-information');
      const newProductUrl = productInformation?.getAttribute('data-url');

      // Update the main product URL if it changed (combined listing product swap)
      if (newProductUrl && newProductUrl !== this.mainProductURL) {
        this.mainProductURL = newProductUrl;
        this.dataset.url = newProductUrl;
      }

      // Full DOM update using the same logic as valid variants
      const productURL = newProductUrl || context.productURL || this.mainProductURL;
      this.replaceElements(html, { ...context, productURL });
    }

    updateDOMWithData(context) {
      if (context.revision !== undefined && context.revision !== this.variantRevision) return;
      if (!this.dataCache.has(context.fetchURL)) {
        this.showVariantSafetyMessage(this.variantSafetyData?.messages?.updateFailed);
        return;
      }
      /* ===== Update the UI with the cached data ===== */
      if (this.enableURLUpdate) this.updateURL();

      const data = this.dataCache.get(context.fetchURL);
      const html = this.parseHTML(data);
      if (this.variantSafetyActive) {
        const renderedId = html.querySelector('product-information product-form [name="id"]')?.value;
        if (String(this.resolveSafetyVariant()?.id) !== renderedId) {
          this.showVariantSafetyMessage(this.variantSafetyData.messages.updateFailed);
          return;
        }
      }
      this.updateDOM(html, context);
      if (context.revision !== undefined && context.revision !== this.variantRevision) return;
      this.productForm = this.querySelector('product-form');
      this.unlockVariantPurchase();
    }

    parseHTML(data) {
      /* ===== Parse the fetched data into a DOM object ===== */
      return new DOMParser().parseFromString(data, 'text/html');
    }

    updateDOM(html, context = {}) {
      /* ===== Update the DOM with the fetched data ===== */
      this.replaceElements(html, context);

      if (context.fromSlideChange && !this.variantSafetyActive) return;
      if (this.variantSafetyActive) {
        this.closest('[data-product-content-wrapper]')?.querySelectorAll('product-media').forEach(media => {
          if (this.openingProductChoiceId && this.openingProductChoiceId === this.currentVariant?.id) media.releaseOpeningProductMedia?.();
          media.updateSelectedVariant?.(this.currentVariant);
        });
      }

      if (this.openingProductChoiceId && this.openingProductChoiceId === this.currentVariant?.id) this.syncOpeningAppMedia(this.currentVariant);

      // Emit an event to let other components know the variant was updated
      eventBus.emit('variant:updated', {
        variant: this.currentVariant,
        sectionId: this.sectionId,
        isCombinedListing: context.isCombinedListing
      });
    }

    toggleAddButton(enable) {
      /* ===== Toggle the add to cart button based on the variant availability ===== */
      const addButton = this.productForm?.querySelector('[name="add"]');
      if (addButton) {
        addButton.toggleAttribute('disabled', !enable);
      }
    }

    updateURL() {
      /* ===== Update the URL with the current variant ID ===== */
      if (this.currentVariant) {
        window.history.replaceState({}, '', `${this.productFetchUrl}`);
      }
    }

    updateOptions(html, context = {}) {
      /* ===== Update the product options with the new data ===== */
      if (!html) return;

      const productInformation = html.querySelector(`product-information[data-url="${context.productURL}"]`);
      if (!productInformation) return;
    
      const currentElements = Array.from(this.querySelectorAll('[data-product-options]'));

      // Update existing options
      currentElements.forEach(currentElement => {
        const currentUpdateId = currentElement.getAttribute('data-update-id');
        const newElement = productInformation.querySelector(`[data-update-id="${currentUpdateId}"]`);
        if (newElement) {
          // Replace the element if it has the data-replace-content attribute, otherwise update the innerHTML
          currentElement.replaceWith(newElement);
        }
      });
    }

    replaceElements(html, context = {}) {
      /* ===== Replace elements in the DOM with new elements ===== */
      if (!html) return;
    
      const productInformation = html.querySelector(`product-information[data-url="${context.productURL}"]`);
      if (!productInformation) return;

      const currentElements = Array.from(this.querySelectorAll('[data-update-id]'));
      const newElements = Array.from(productInformation.querySelectorAll('[data-update-id]'));
    
      // Update existing elements and track their order
      currentElements.forEach(currentElement => {
        const currentUpdateId = currentElement.getAttribute('data-update-id');
        const newElement = productInformation.querySelector(`[data-update-id="${currentUpdateId}"]`);
        if (newElement) {
          // Replace the element if it has the data-replace-content attribute, otherwise update the innerHTML
          newElement.hasAttribute('data-replace-content') ? currentElement.replaceWith(newElement) : currentElement.innerHTML = newElement.innerHTML;
        }
      });
    
      // Add new elements in the correct order
      newElements.forEach(newElement => {
        const newUpdateId = newElement.getAttribute('data-update-id');
        const existingElement = this.querySelector(`[data-update-id="${newUpdateId}"]`);
    
        if (!existingElement) {
          // Determine the correct position to insert the new element
          let inserted = false;
          for (let i = 0; i < currentElements.length; i++) {
            const currentElement = currentElements[i];
            const currentUpdateId = currentElement.getAttribute('data-update-id');
            if (currentUpdateId > newUpdateId) {
              currentElement.insertAdjacentElement('beforebegin', newElement.cloneNode(true));
              inserted = true;
              break;
            }
          }
          // If not inserted, append to the end
          if (!inserted) {
            this.appendChild(newElement.cloneNode(true));
          }
        }
      });

      const productMedia = html.querySelector('[data-product-media-wrapper]');
      const productWrapper = this.closest('[data-product-content-wrapper]');
      const currentProductMedia = productWrapper?.querySelector('[data-product-media-wrapper]');

      // Update the badges if they exist
      const currentBadges = currentProductMedia ? currentProductMedia.querySelectorAll('[data-product-badge]') : null;
      const newBadges = productMedia ? productMedia.querySelectorAll('[data-product-badge]') : null;

      if (currentBadges && newBadges && !this.showOnlyVariantMedia) {
        currentBadges.forEach((badge, index) => {
          const newBadge = newBadges[index];
          if (newBadge) {
            badge.replaceWith(newBadge);
          }
        });
      }
    
      if (this.isCombinedListing && context.isCombinedListing || this.showOnlyVariantMedia) {
        const mediaSources = productMedia?.getAttribute('data-media-sources');
        const currentMediaSources = currentProductMedia?.getAttribute('data-media-sources');
        if (mediaSources === currentMediaSources) return;
        
        if (productMedia && currentProductMedia) currentProductMedia.replaceWith(productMedia);

        eventBus.emit('product:media:updated', {
          variant: this.currentVariant,
          sectionId: this.sectionId,
          isCombinedListing: context.isCombinedListing
        });
      }
    
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    }    
  });
}
/******/ })()
;

